// 企業従業員管理機能の型定義

export enum CompanyEmployeeRole {
  COMPANY_ADMIN = 'company_admin',
  HR = 'hr',
  EMPLOYEE = 'employee',
}

export enum EmployeeStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum PasswordOption {
  AUTO = 'auto',
  MANUAL = 'manual',
}

// 従業員情報
export interface CompanyEmployee {
  id: number;
  companyId: number;
  user: {
    id: number;
    fullName: string;
    email: string;
    lastLoginAt?: string;
    isVerified?: boolean;
  };
  role: CompanyEmployeeRole;
  department?: string;
  jobTitle?: string;
  status: EmployeeStatus;
  createdAt: string;
  updatedAt?: string;
}

// 従業員追加フォームのデータ
export interface AddEmployeeFormData {
  fullName: string;
  email: string;
  department?: string;
  jobTitle?: string;
  role: CompanyEmployeeRole;
  passwordOption: PasswordOption;
  password?: string;
}

// 従業員更新フォームのデータ
export interface UpdateEmployeeFormData {
  fullName?: string;
  department?: string;
  jobTitle?: string;
  role?: CompanyEmployeeRole;
  status?: EmployeeStatus;
}

// 従業員一覧の検索・フィルター
export interface EmployeeListFilters {
  search?: string;
  role?: CompanyEmployeeRole;
  status?: EmployeeStatus;
  sortBy?: 'name' | 'created_at';
  sortOrder?: 'asc' | 'desc';
  page?: number;
  limit?: number;
}

// API レスポンス型
export interface EmployeeListResponse {
  success: true;
  data: {
    employees: CompanyEmployee[];
    total: number;
    page: number;
    totalPages: number;
  };
}

export interface AddEmployeeResponse {
  success: true;
  data: {
    employeeId: number;
    userId: number;
    temporaryPassword?: string;
    emailSent: boolean;
    message: string;
  };
}

export interface UpdateEmployeeResponse {
  success: true;
  data: {
    employee: CompanyEmployee;
    message: string;
  };
}


// エラーレスポンス型
export interface EmployeeErrorResponse {
  success: false;
  error: string;
  message: string;
  details?: any;
}

// 従業員管理状態（React Context用）
export interface EmployeeManagementState {
  employees: CompanyEmployee[];
  loading: boolean;
  filters: EmployeeListFilters;
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  modals: {
    addEmployee: boolean;
    editEmployee: boolean;
    employeeDetail: boolean;
  };
  selectedEmployee?: CompanyEmployee;
}

// 従業員管理のアクション型
export type EmployeeManagementAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_EMPLOYEES'; payload: CompanyEmployee[] }
  | { type: 'SET_FILTERS'; payload: Partial<EmployeeListFilters> }
  | {
      type: 'SET_PAGINATION';
      payload: Partial<EmployeeManagementState['pagination']>;
    }
  | { type: 'OPEN_ADD_MODAL' }
  | { type: 'CLOSE_ADD_MODAL' }
  | { type: 'OPEN_EDIT_MODAL'; payload: CompanyEmployee }
  | { type: 'CLOSE_EDIT_MODAL' }
  | { type: 'OPEN_DETAIL_MODAL'; payload: CompanyEmployee }
  | { type: 'CLOSE_DETAIL_MODAL' }
  | { type: 'ADD_EMPLOYEE'; payload: CompanyEmployee }
  | { type: 'UPDATE_EMPLOYEE'; payload: CompanyEmployee };
